<template>
    <aside class="parametres-container" :class="{disabled: !paramBtnActive, disabled_after_offer: !isEditable}">
        <div class="title-container">
            <h2>{{translate("parameters")}}</h2>
        </div>

        <transition-group name="list" tag="div" class="elements-container">
            <div v-for="(param, param_id) in getfourthStepParameters" v-if="param.active" class="element"
                 :key="param.title">
                <h3 class="title" v-html="translate(param_id)"/>
                <!-- NVS-78 Ikona kalkulatora przy Wydajności -->
                <div class="calculator" v-if="param_id == 'performance'" @click="submenu = !submenu">
                    <img src="/gfx/svg/calculator.svg" alt="calculator_icon"/>
                </div>

                <div v-for="(option, option_id) in param.options"
                     class="option-container"
                     :class="{radio_type : option.type === 'radio', select_type : option.type === 'select', disabled: !paramBtnActive}">

                    <div v-if="option.type === 'radio'"
                         v-for="(element, element_id) in option.elements"
                         class="radio-btn"
                         :class="{checked : element.active, disabled: !paramBtnActive,}">
                        <input type="radio"
                               :class="{disabled_after_offer: !isEditable}"
                               :id="param_id + '_' + option_id + '_' + element_id"
                               :value="element.value"
                               :checked="element.active"
                               @change="selectElementOfOptionInParam(param_id, option_id, element_id), enableCalcButton()"
                               hidden>
                        <label :for="param_id + '_' + option_id + '_' + element_id"
                               v-html="translate((element.displayValue ? element.displayValue : element.value), false)"
                               :class="{disabled: !paramBtnActive}"/>
                    </div>

                    <div v-if="option.type === 'select'" class="value_with_select-container">
                        <input v-if="typeof (param.value) !== 'undefined'" type="text"
                               :class="{disabled_after_offer: !isEditable}"
                               :step="getStep(option)"
                               :id="param_id + '_' + 'value'"
                               :value="translate(calcUnit(param, option), false)"
                               @input="setFilter(param_id, option, $event.target.value, $event)"
                        >
                        <span v-if="typeof (option.value) !== 'undefined'"
                              class="option-title"
                              v-html="translate(option.displayValue ? option.displayValue : option.value)"/>
                        <div class="custom-select">
                            <div class="selected_item"
                                 v-for="(element, element_id) in option.elements"
                                 v-if="element.active"
                                 :class="{with_title : typeof (option.value) !== 'undefined', own_item_style:  param_id == 'ex'  }">
                                <span class="value"
                                      v-html="translate((element.displayValue ? element.displayValue : element.value), false)"/>
                                <span class="icon-bottom_arrow"/>
                            </div>
                            <div class="items-container">
                                <div class="item"
                                     v-for="(element, element_id) in option.elements" v-if="!element.hidden"
                                     :id="param_id + '_' + option_id + '_' + element_id"
                                     @click="selectElementOfOptionInParam(param_id, option_id, element_id), enableCalcButton()"
                                     v-html="translate((element.displayValue ? element.displayValue : element.value), false)"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="param_id == 'material_amount'" class="material-compaction-txt"
                     :class="{disabled_after_offer: !isEditable}">
                    <h4 class="title">{{translate("material_density")}}</h4>
                    <div v-for="(option, option_id) in getfourthStepParameters.material_density.options"
                         class="option-container material-compact"
                         :class="{radio_type : option.type === 'radio', select_type : option.type === 'select', disabled_after_offer: !isEditable}">
                        <div class="calculated-value">{{calcMaterialDensity()}}</div>
                        <div v-if="option.type === 'select'" class="value_with_select-container">
                            <div class="custom-select" :class="{disabled_after_offer: !isEditable}">
                                <div class="selected_item"
                                     v-for="(element, element_id) in option.elements"
                                     v-if="element.active"
                                     :class="{with_title : typeof (option.value) !== 'undefined'}">
                                <span class="value"
                                      v-html="translate((element.displayValue ? element.displayValue : element.value), false)"/>
                                    <span class="icon-bottom_arrow"/>
                                </div>
                                <div class="items-container">
                                    <div class="item"
                                         v-for="(element, element_id) in option.elements"
                                         :id="param_id + '_' + option_id + '_' + element_id"
                                         @click="selectElementOfOptionInParam('material_density', option_id, element_id), enableCalcButton()"
                                         v-html="translate((element.displayValue ? element.displayValue : element.value), false)"
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </transition-group>

        <!-- NVS-78 Element submenu wyświetlany po kliknięciu ikony kalkulatora -->
        <transition name="fade">
            <div class="submenu" v-if="submenu">
                <div class="title-container">
                    <h2>{{translate("normal_units_calculator")}}</h2>
                    <button type="button" class="btn-close" @click="submenu = false"> x</button>
                </div>
                <transition-group name="list" tag="div" class="elements-container">
                    <div v-for="(param, param_id) in getCalculatorParameters" v-if="param.active" class="element" :key="param.title">
                        <h3 class="title" v-html="clearTextTransformInBrackets(translate(param_id))"/>
                        <div v-for="(option, option_id) in param.options"
                            class="option-container"
                            :class="{radio_type : option.type === 'radio', select_type : option.type === 'select', disabled: !paramBtnActive, disabled_input: option.disabled}">

                            <div v-if="option.type === 'radio'"
                                v-for="(element, element_id) in option.elements"
                                class="radio-btn"
                                :class="{checked : element.active, disabled: !paramBtnActive,}">
                                <input type="radio"
                                    :class="{disabled_after_offer: !isEditable}"
                                    :id="param_id + '_' + option_id + '_' + element_id"
                                    :value="element.value"
                                    :checked="element.active"
                                    @change="selectElementOfOptionInParam(param_id, option_id, element_id)"
                                    hidden>
                                <label :for="param_id + '_' + option_id + '_' + element_id"
                                    v-html="translate((element.displayValue ? element.displayValue : element.value), false)"
                                    :class="{disabled: !paramBtnActive}"/>
                            </div>

                            <div v-if="option.disabled" class="calculated-value">{{ param_id == 'atmospheric_pressure' ? calcAtmosphericPressure() : param_id == 'calculated_performance' ? calcPerformance() : param_id == 'calculated_pressure' ? calcPressure() : 0 }}</div>
                            <div v-if="option.type === 'select'" class="value_with_select-container">
                                <input v-if="typeof (param.value) !== 'undefined' && !option.disabled" type="text"
                                    :class="{disabled_after_offer: !isEditable}"
                                    :step="getStep(option)"
                                    :id="param_id + '_' + 'value'"
                                    :value="translate(calcUnit(param, option), false)"
                                    @input="setFilter(param_id, option, $event.target.value, $event)"
                                >
                                <span v-if="typeof (option.value) !== 'undefined'"
                                    class="option-title"
                                    v-html="translate(option.displayValue ? option.displayValue : option.value)"/>
                                <div class="custom-select">
                                    <div class="selected_item"
                                        v-for="(element, element_id) in option.elements"
                                        v-if="element.active"
                                        :class="{with_title : typeof (option.value) !== 'undefined', own_item_style:  param_id == 'ex'  }">
                                        <span class="extra" v-if="param_id == 'normal_performance'">N</span>
                                        <span class="value"
                                            v-html="translate((element.displayValue ? element.displayValue : element.value), false)"/>
                                        <span class="icon-bottom_arrow"/>
                                    </div>
                                    <div class="items-container">
                                        <div class="item"
                                            v-for="(element, element_id) in option.elements"
                                            :id="param_id + '_' + option_id + '_' + element_id"
                                            @click="selectElementOfOptionInParam(param_id, option_id, element_id)"
                                            v-html="translate((element.displayValue ? element.displayValue : element.value), false)"
                                        >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
                <div class="btn" @click="enterPressureValue()">
                    <span>{{translate("enter")}}</span>
                </div>
            </div>
        </transition>

        <span @click="cleanParamsValue" class="clean_parameters-btn">{{translate("reset_parameters")}}</span>

        <adjust-result-btn/>

    </aside>
</template>

<script>
    import AdjustResultBtn from "@/components/configuration_steps/fourthStep/AdjustResultBtn";
    import debounce from "lodash.debounce";

    export default {
        name: "ParametersAside",
        data() {
            return {
                allValues: [],
                paramBtnActive: true,
                filterChanges: [],
                submenu: false
            }
        },
        components: {
            AdjustResultBtn
        },
        methods: {
            calcMaterialDensity() {
                try {
                    let value = this.getfourthStepParameters.material_amount.value / 3.6 / this.getfourthStepParameters.performance.value / 1000;

                    let param = {value: value};
                    let option = {elements: {1: this.$store.state.ValueUnitMap['material_density'].selected}};

                    let arg = {
                        type: 'calcUnit',
                        param: param,
                        option: option,
                        out: ""
                    }

                    this.$store.commit(arg);

                    return arg.out;
                } catch (e) {
                    return 0;
                }
            },

            // NVS-107 Metoda zamieniająca to co w nawiasach na małe litery
            clearTextTransformInBrackets (text) {
                return text.replace('(', `<span style="text-transform: none;">(`).replace(')', `)</span>`)
            },


            // NVS-78 Metoda przenosząca wyliczoną wartość do pola Wydajność
            enterPressureValue () {
                this.getfourthStepParameters.performance.value = this.getCalculatorParameters.calculated_performance.value
                this.submenu = false
            },

            // NVS-78 Metoda obliczająca wartość ciśnienia atmosferycznego
            calcAtmosphericPressure () {
                try {
                    let value = 101325 * Math.pow(1 - (6.5 * (this.getfourthStepParameters.above_sea.value / 1000)) / 288.15 /* NVS-179 this.getfourthStepParameters.temperature.value */, 5.256)

                    let param = {value: value};
                    let option = {elements: {1: this.$store.state.ValueUnitMap['pressure'].selected}};

                    let arg = {
                        type: 'calcUnit',
                        param: param,
                        option: option,
                        out: ""
                    }

                    this.$store.commit(arg);

                    this.getCalculatorParameters.atmospheric_pressure.value = value
                    return arg.out;
                } catch (e) {
                    return 0;
                }
            },

            // NVS-107 Metoda obliczająca ciśnienie dla gęstości 1.2
            calcPressure () {
                try {
                    let value = this.getfourthStepParameters.pressure.value * (1.2 / ((3.468 * this.getCalculatorParameters.atmospheric_pressure.value) / (1000 * this.getfourthStepParameters.temperature.value)))

                    let param = {value: value};
                    let option = {elements: {1: this.$store.state.ValueUnitMap['pressure'].selected}};

                    let arg = {
                        type: 'calcUnit',
                        param: param,
                        option: option,
                        out: ""
                    }

                    this.$store.commit(arg);

                    this.getCalculatorParameters.calculated_pressure.value = value
                    return arg.out;
                } catch (e) {
                    return 0;
                }
            },

            // NVS-78 Metoda obliczająca wydajność w kalkulatorze na podstawie wprowadzonych wartości
            calcPerformance () {
                try {
                    let value = this.getCalculatorParameters.normal_performance.value * (1.293 / ((this.getCalculatorParameters.atmospheric_pressure.value - this.getfourthStepParameters.pressure.value) / (287.05 * (this.getfourthStepParameters.temperature.value - 0.15))))

                    let param = {value: value};
                    let option = {elements: {1: this.$store.state.ValueUnitMap['performance'].selected}};

                    let arg = {
                        type: 'calcUnit',
                        param: param,
                        option: option,
                        out: ""
                    }

                    this.$store.commit(arg);

                    this.getCalculatorParameters.calculated_performance.value = value
                    return arg.out;
                } catch (e) {
                    return 0;
                }
            },

            setFilter(element, value, type, hook) {
                this.filterChanges.push({
                    element, value, type, hook
                });
                this.filterValues();
            },

            filterValues: debounce(function () {
                for (let change in this.filterChanges) {
                    if (isNaN(change)) break;
                    let a = this.filterChanges[change];
                    this.changeParamValue(a.element, a.value, a.type, a.hook);
                }
                this.filterChanges = [];
                this.enableCalcButton();
            }, 700),

            toggleExpandOfCustomSelect(e) {

                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },

            cleanParamsValue() {
                this.$store.commit('resetOfferState');
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            getStep(option) {
                let arg = {
                    type: 'getActiveElementOfParamOption',
                    option: option,
                    out: 0
                }

                this.$store.commit(arg);

                let zero = "0";
                let decimalPlaces = 0;

                if (arg.out && arg.out.unit && arg.out.unit.decimal_places)
                    decimalPlaces = parseInt(arg.out.unit.decimal_places);

                if (decimalPlaces <= 0) {
                    return zero;
                } else {
                    return "0." + zero.repeat(decimalPlaces - 1) + 1;
                }
            },

            calcUnit(param, option) {
                if (param.value == "nieobliczalne" || param.value == "+nieskończoność" || param.value == "-nieskończoność")
                    return "-";

                if (!option.hasOwnProperty('unitType'))
                    return param.value;


                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            enableCalcButton() {
                this.$store.commit({
                    type: 'toggleAdjustResultBtn',
                    disabled: false
                })

            },

            // Metoda zapisująca stan pól tekstowych
            changeParamValue(param_id, option, value, hook) {

                if (value === '' || null) {
                    return;
                }

                // NVS-78 Dokładam sprawdzenie na wszelki wypadek
                if (this.$store.state.fourthStepParameters.hasOwnProperty(param_id)) {
                    this.$store.commit({
                        type: 'changeParamValue',
                        param_id: param_id,
                        option: option,
                        value: value
                    })
                }

                // NVS-78 Jeśli wybrana opcja występuje w parametrach kalkulatora wysyłam do innej mutacji
                if (this.$store.state.calculatorParameters.hasOwnProperty(param_id)) {
                    this.$store.commit({
                        type: 'changeParamValueCalc',
                        param_id: param_id,
                        option: option,
                        value: value
                    })
                }

                if (window.mouseDown)
                    return;

                let tmpRound = {
                    type: 'roundValue',
                    elements: option.elements,
                    value: value,
                    displayUser: true,
                    out: ""
                }

                this.$store.commit("roundValue", tmpRound);
                hook.value = tmpRound.out;
            },

            // Metoda zapisująca stan pól typu radio
            selectElementOfOptionInParam(param_id, option_id, element_id) {

                // NVS-78 Dokładam sprawdzenie czy jest taki parametr na wszelki wypadek
                if (this.$store.state.fourthStepParameters.hasOwnProperty(param_id)) {
                    this.$store.commit({
                        type: 'selectElementOfOptionInParam',
                        param_id: param_id,
                        option_id: option_id,
                        element_id: element_id
                    });
                }

                // NVS-78 Wrzucamy do calculatorParameters jeśli wybrana opcja występuje w parametrach kalkulatora 
                if (this.$store.state.calculatorParameters.hasOwnProperty(param_id)) {
                    this.$store.commit({
                        type: 'selectElementOfOptionInParamCalc',
                        param_id: param_id,
                        option_id: option_id,
                        element_id: element_id
                    });
                }

                // NVS-78 Wyjątek dla ciśnienia atmosferycznego - nie ma innych pól zależnych (gdyby się pojawiły warto wypracować mechanizm ich wiązania na poziomie store)
                if (param_id == 'atmospheric_pressure')
                    this.$store.state.calculatorParameters[param_id].options[1].disabled = !this.atmosphericPressureEditable
                
                // NVS-88 Wyjątek dla ex - pole zależne, ale inaczej niż powyżej
                if (param_id == 'ex') {
                    this.getOptionByName(this.$store.state.fourthStepParameters, 'ex', 'ex_number', '1 + 2').hidden = !this.exEnable
                    this.getOptionByName(this.$store.state.fourthStepParameters, 'ex', 'ex_number', '21 + 22').hidden = !this.exEnable

                    const selectedValue = this.getSelectedElementOfOption(this.$store.state.fourthStepParameters, 'ex', 'ex_number').value
                    if (!this.exEnable && (selectedValue == '1 + 2' || selectedValue == '21 + 22')) {
                        this.getOptionByName(this.$store.state.fourthStepParameters, 'ex', 'ex_number', '1 + 2').active = false
                        this.getOptionByName(this.$store.state.fourthStepParameters, 'ex', 'ex_number', '21 + 22').active = false
                        this.getOptionByName(this.$store.state.fourthStepParameters, 'ex', 'ex_number', '22').active = true
                    }
                }
            },

            // NVS-78 Metoda zwraca wybraną opcję pola
            getSelectedElementOfOption(elements, elementId, optionName) {
                if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                    for (let option of Object.values(elements[elementId].options))
                        if (option.name == optionName)
                            for (let element of Object.values(option.elements))
                                if (element.active) return element;

                return {value: null};
            },

            // NVS-88 Metoda zwracająca opcję pola po wartości
            getOptionByName(elements, elementId, optionName, value) {
                if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                    for (let option of Object.values(elements[elementId].options))
                        if (option.name == optionName)
                            for (let element of Object.values(option.elements))
                                if (element.value == value) return element;

                return null;
            }
        },

        computed: {

            isEditable() {
                return this.$store.getters.isOfferEditable;
            },

            getfourthStepParameters() {
                return this.$store.state.fourthStepParameters;
            },

            getCalculatorParameters () {
                return this.$store.state.calculatorParameters;
            },

            // NVS-78 Metoda sprawdzająca czy pole z ciśnieniem atmosferycznym może być edytowane
            // Jest to zależne od wyboru w polu radio atmosphericPressureType
            atmosphericPressureEditable () {
                return this.getSelectedElementOfOption(this.$store.state.calculatorParameters, 'atmospheric_pressure', 'atmosphericPressureType').value == 'enter';
            },

            // NVS-88 Metoda sprawdzająca czy pokazać dodatkowe strefy ex
            exEnable () {
                return this.getSelectedElementOfOption(this.$store.state.fourthStepParameters, 'ex', 'where').value == 'inside_and_outside';
            }
        },

        mounted() {
            document.addEventListener("click", this.toggleExpandOfCustomSelect);

            this.$root.$on('disabledParamAside', () => {
                this.paramBtnActive = false;
            })

            this.$root.$on('enabledParamAside', () => {
                this.paramBtnActive = true;
            })

        },

        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        }
    }
</script>

<style scoped lang="scss">

    .list-enter-active, .list-leave-active {
        transition: all 0.3s;
    }

    .list-enter, .list-leave-to {
        opacity: 0;
    }
</style>